module.exports = __webpack_public_path__ + "static/media/trader-joe.55da7323.svg";